// src/utils/comboStatsFromGames.js
// นับคอมโบ 2/3 ตัวจาก log เกม ให้อยู่ในรูปเดียวกับที่ชีท Combo_Stats ส่งออกมา
// ({ combo, win, total, losses, comboType }) เพื่อเสียบแทนกันได้ตรงๆ
//
// ทำไมต้องมี: ชีท Combo_Stats เป็น pivot ที่เก็บไม่ครบ — ไฟล์ WINTER ให้มา 41 คู่
// จาก 216 คู่ที่เล่นจริง และบล็อก 3 ตัวอ่านไม่ออกเลย หน้าไหนที่อ่านจากชีทตรงๆ
// จึงเห็นคอมโบไม่ครบ ทั้งที่ log มีข้อมูลอยู่แล้ว
import { rolePicks, isFsWin } from "./heroMatchups";

// ชุดเดียวกับแท็บบนหน้า TierData เพื่อให้ป้ายชนิดคอมโบตรงกันทุกหน้า
export const COMBO_ROLE_SETS = [
  { roles: ["MID", "SUP"], label: "2-heroes (MID+SUP)" },
  { roles: ["ADL", "SUP"], label: "2-heroes (ADL+SUP)" },
  { roles: ["DSL", "JUG"], label: "2-heroes (DSL+Jungle)" },
  { roles: ["JUG", "SUP"], label: "2-heroes (JUG+SUP)" },
  { roles: ["JUG", "MID"], label: "2-heroes (JUG+MID)" },
  { roles: ["JUG", "MID", "SUP"], label: "3-heroes (JUG+MID+SUP)" },
  { roles: ["JUG", "ADL", "SUP"], label: "3-heroes (JUG+ADL+SUP)" },
  { roles: ["MID", "ADL", "SUP"], label: "3-heroes (MID+ADL+SUP)" },
];

const PLAYABLE = new Set(["rpl", "scrim"]);

/** @returns {{ combo2: object[], combo3: object[] }} เรียงจากเล่นบ่อยสุด */
export function buildComboStatsFromGames(games, side = "fs") {
  const playable = (Array.isArray(games) ? games : []).filter((g) =>
    PLAYABLE.has(String(g?.type || "").trim().toLowerCase())
  );

  const out = { combo2: [], combo3: [] };
  if (!playable.length) return out;

  for (const { roles, label } of COMBO_ROLE_SETS) {
    const acc = new Map();
    for (const game of playable) {
      const mine = rolePicks(game, side);
      if (!roles.every((r) => mine[r])) continue;
      const key = roles.map((r) => mine[r]).join(" + ");
      const slot = acc.get(key) || { total: 0, win: 0 };
      slot.total += 1;
      if (side === "op" ? !isFsWin(game) : isFsWin(game)) slot.win += 1;
      acc.set(key, slot);
    }
    const rows = [...acc.entries()]
      .map(([combo, v]) => ({
        combo,
        win: v.win,
        total: v.total,
        losses: v.total - v.win,
        comboType: label,
      }))
      .sort((a, b) => b.total - a.total || b.win - a.win || a.combo.localeCompare(b.combo));
    (roles.length === 3 ? out.combo3 : out.combo2).push(...rows);
  }

  return out;
}

/**
 * log มาก่อนชีท ชีทเป็นตัวสำรองเมื่อไฟล์ไม่มี log (เช่นไฟล์ที่มีแต่ตารางสรุป)
 * คีย์อื่นของชีท (combo2MidRoam / combo2DslJug ฯลฯ) ส่งต่อไปเหมือนเดิม
 */
export function mergeComboStats(fromGames, fromSheet) {
  const sheet = fromSheet || {};
  const log = fromGames || {};
  const pick = (a, b) => (Array.isArray(a) && a.length ? a : b || []);
  return {
    ...sheet,
    combo2: pick(log.combo2, sheet.combo2),
    combo3: pick(log.combo3, sheet.combo3),
    source: {
      combo2: log.combo2?.length ? "games" : "sheet",
      combo3: log.combo3?.length ? "games" : "sheet",
    },
  };
}
